module.exports = __webpack_public_path__ + "static/media/PDSLogo-1.4c0d3406.jpg";